const moveReducer = (state = {horizontal:0, vertical:0}, action) => {

    switch(action.type){
        case "moveUp":
            return{
                ...state, horizontal: state.horizontal - 4
            }
        case "moveDown":
            return{
                ...state, horizontal: state.horizontal + 4
            }
        case "moveLeft":
            return{
                ...state, vertical: state.vertical - 4
            }
        case "moveRight":
            return{
                ...state, vertical: state.vertical + 4
            }
        default:
            return state
    }
}

export default moveReducer